// extracted by mini-css-extract-plugin
export default {"formItemsWrapper":"ProjectCreateUpdateFormItems_formItemsWrapper__FwaKY"};